import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Fragment } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import BankingAccountFormModal from '../../../components/BankingAccountForm/BankingAccountFormModal';
import Button from '../../../components/Button';
import CircledIcon from '../../../components/CircledIcon';
import PreferedCard from '../../../components/PreferedCard';
import useModal from '../../../hooks/useModal';
import { accountNumberMask } from '../../../utils/utils';
import DeleteModal from '../../widgets/deleteModal/DeleteModal';
import AddNewBankModal from '../../widgets/retireOnlineModals/addNewBankModal/AddNewBankModal';

const BankingTabContent = ({
  bankCheckingAccount,
  setbankCheckingAccount,
  bankSavingsAccount,
  setbankSavingsAccount,
}: any) => {
  const [
    showDeleteFamilyFundsModal,
    handleDeleteFamilyFundsShow,
    handleDeleteFamilyFundsClose,
  ] = useModal();

  const [
    showDeleteMainAccountModal,
    handleDeleteMainAccountShow,
    handleDeleteMainAccountClose,
  ] = useModal();

  const [
    showAddNewBankingAccountModal,
    handleAddNewBankingAccountShow,
    handleAddNewBankingAccountClose,
  ] = useModal();

  const [
    showEditMainAccountModal,
    handleEditMainAccountShow,
    handleEditMainAccountClose,
  ] = useModal();

  const [
    showEditFamilyFundsModal,
    handleEditFamilyFundsShow,
    handleEditFamilyFundsClose,
  ] = useModal();

  const handleSubmitBankAccount = (formData: any) => {
    console.log('submit', formData);
    if (formData.type === 'Cheking') {
      setbankCheckingAccount(formData);
    }

    if (formData.type === 'Savings') {
      setbankSavingsAccount(formData);
    }

    handleAddNewBankingAccountClose();
    handleEditMainAccountClose();
    handleEditFamilyFundsClose();
  };

  return (
    <Fragment>
      <section className={'w-100 d-flex justify-content-between mt-7'}>
        <div className={'d-flex align-items-center'}>
          <CircledIcon
            variant={'icon-emphasized'}
            icon={light('building-columns')}
          />
          <h4 className={'ms-7 mb-0 text-sm-20-lg-32'}>Bank Accounts</h4>
        </div>
        <div className={'d-none d-lg-block'}>
          <Button
            size={'sm'}
            rightIcon={light('circle-plus')}
            onMouseDown={handleAddNewBankingAccountShow}
          >
            Add new
          </Button>
          <AddNewBankModal
            showModal={showAddNewBankingAccountModal}
            handleClose={handleAddNewBankingAccountClose}
            handleAddNewBank={handleSubmitBankAccount}
            banks={[bankCheckingAccount, bankSavingsAccount]}
          />
        </div>
      </section>
      <Row className={'mt-5'}>
        <Col lg={4} className={'mt-7'}>
          <PreferedCard
            title={bankCheckingAccount.accountNickname}
            className={'text-capitalize'}
            editButtonName={'Edit bank'}
            onDelete={handleDeleteMainAccountShow}
            onEdit={handleEditMainAccountShow}
            isSwitch={false}
          >
            {
              <Fragment>
                <div className={'fw-light text-light-grey text-capitalize'}>
                  {bankCheckingAccount.type}
                </div>
                <div className={'fs-6'}>
                  {accountNumberMask(bankCheckingAccount.iban)}
                </div>
                <div>{bankCheckingAccount.name}</div>
              </Fragment>
            }
          </PreferedCard>
          <BankingAccountFormModal
            showModal={showEditMainAccountModal}
            handleClose={handleEditMainAccountClose}
            handleSubmit={handleSubmitBankAccount}
            existingBankingAccountDetails={bankCheckingAccount}
          />
          <DeleteModal
            showModal={showDeleteMainAccountModal}
            handleClose={handleDeleteMainAccountClose}
            handleSubmit={handleDeleteMainAccountClose}
            title="Delete Banking Accounts"
          >
            <Container>
              <Row className="text-fs-6">
                Are you sure you want to delete this banking account?
              </Row>
              <Row>
                <Col className="p-0 pt-4 col-12 col-lg-6">
                  <PreferedCard
                    className="border-light-gray text-capitalize"
                    id="pc-3"
                    title={bankCheckingAccount.accountNickname}
                    isSwitch={false}
                    isDismissable={false}
                  >
                    <Fragment>
                      <div
                        className={'fw-light text-light-grey text-capitalize'}
                      >
                        {bankCheckingAccount.type}
                      </div>
                      <div className={'fs-6'}>
                        {accountNumberMask(bankCheckingAccount.iban)}
                      </div>
                      <div>{bankCheckingAccount.name}</div>
                    </Fragment>
                  </PreferedCard>
                </Col>
              </Row>
            </Container>
          </DeleteModal>
        </Col>
        <Col lg={4} className={'mt-7'}>
          <PreferedCard
            title={bankSavingsAccount.accountNickname}
            className={'text-capitalize'}
            editButtonName={'Edit bank'}
            onDelete={handleDeleteFamilyFundsShow}
            onEdit={handleEditFamilyFundsShow}
            isSwitch={false}
          >
            {
              <Fragment>
                <div className={'fw-light text-light-grey text-capitalize'}>
                  {bankSavingsAccount.type}
                </div>
                <div className={'fs-6'}>
                  {accountNumberMask(bankSavingsAccount.iban)}
                </div>
                <div>{bankSavingsAccount.name}</div>
              </Fragment>
            }
          </PreferedCard>
          <BankingAccountFormModal
            showModal={showEditFamilyFundsModal}
            handleClose={handleEditFamilyFundsClose}
            handleSubmit={handleSubmitBankAccount}
            existingBankingAccountDetails={bankSavingsAccount}
          />
          <DeleteModal
            showModal={showDeleteFamilyFundsModal}
            handleClose={handleDeleteFamilyFundsClose}
            handleSubmit={handleDeleteFamilyFundsClose}
            title="Delete Banking Accounts"
          >
            <Container>
              <Row className="text-fs-6">
                Are you sure you want to delete this banking account?
              </Row>
              <Row>
                <Col className="p-0 pt-4 col-12 col-lg-6">
                  <PreferedCard
                    className="border-light-gray text-capitalize"
                    id="pc-3"
                    title={bankSavingsAccount.accountNickname}
                    isSwitch={false}
                    isDismissable={false}
                  >
                    <Fragment>
                      <div
                        className={'fw-light text-light-grey text-capitalize'}
                      >
                        {bankSavingsAccount.accountType}
                      </div>
                      <div className={'fs-6'}>
                        {accountNumberMask(bankSavingsAccount.accountNumber)}
                      </div>
                      <div>{bankSavingsAccount.bank}</div>
                    </Fragment>
                  </PreferedCard>
                </Col>
              </Row>
            </Container>
          </DeleteModal>
        </Col>
      </Row>
      <div className={'w-100 mt-7 d-flex flex-column d-lg-none'}>
        <Button
          variant={'primary-outline'}
          rightIcon={light('circle-plus')}
          onMouseDown={handleAddNewBankingAccountShow}
        >
          Add new
        </Button>
      </div>
    </Fragment>
  );
};

export default BankingTabContent;
